import React, {useState, useEffect} from 'react'
import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
import { Ref, cache, copy, session } from '../../../global'
import { tcp, dispatch } from '../../../io'
import Table from '../../state/table'
import { Toast } from '../toast'
const count = {}
const rows = {}
const Side = prop => {
  const {route, param, larr, rarr, username, vendorname, lang, cartCount, owner, vid, uid, verb, visit, u, online, cookie, login, master, connected, vendor} = prop.master
  const park = { ...prop.park }
  // debugger
  const ID = prop.ID
  const v = connected ? prop.OnlineV : prop.V
  const isPurchase = v=='purchase'
  // const [pay, setPay] = useState()
  // IO[_.T].setPay = setPay
  if (u==v) return null
  if (window.opener && !param.cart) return null
  if (ID=='l' && !login && !connected) return null
  if (ID=='t' && u=='online' && !connected) return null
  if (ID=='t' && _.MASTER_.includes(u)) return null
  // if (ID=='t' && u=='pay') return null
  const p = prop.prop(ID)
  const s = prop[ID]
  const show = s.state=='show'
  const db = connected ? vid : uid
  const parkvdbpub = park[v]?.[db]?.[_.PUB]
  const display = isPurchase ? `${master.cart.i} ${cartCount[vid]||''}` : `${parkvdbpub || ''} ${master[v].i}`
  const shard = _.PRIVATE_.includes(v) ? cookie.home : vendor.home
  const pp = {...prop, v, db, pk: isPurchase, ID, compact: true}
  const onClick = e => {
    e.preventDefault()
    e.stopPropagation()
    if (ID=='t' && u=='pay') return Toast({content: [`Cart modifcation not possible on payment.`], response: ['Ok']})
    // if (ID=='t' && pay) return Toast({content: [`Cart modifcation not possible on payment.`], response: ['Ok']})
    prop.slide(ID)
    setTimeout(()=>prop.slide(ID=='t' ? 'l' : 't', 'hide'), 1)
    setTimeout(()=>prop.slide('footer', 'hide'), 1)
    document.getElementById(`${ID}${v}`).classList.remove('clear')
  }
  const buff = {[v]: {[db]: {}}}
  const store = park[v]?.[db] || {}
  const printer = park[v]?.default
  if (show) {
    pp.collapse = false
    if (!rows[v]) {
      if (!printer) buff[v].default = 'find'
      if (db>0 && !store[`0${_.PUB}`]) {
        rows[v] = true
        buff[v][db].default = []
        // tcp({debug: ID, buffer: buff}, shard)
        setTimeout(() => tcp({lang, u, route, buffer: {[shard]: buff}}), 2222)
      }
    }
  }
  // else if (!count[v]) {
  //   count[v] = true
  //   if (db>0 && !store[_.PUB]) {
  //     buff[v][db][_.COUNT] = _.PUB
  //     tcp({[ID]: 1, [_.BUFFER]: buff}, shard)
  //   }
  // }
  const hideClue = prop.ID=='l' ? larr : rarr
  const showClue = prop.ID=='l' ? rarr : larr
  const clue = show ? hideClue : showClue
  const print = prop.ID=='l' ? <>{display}{clue}</> : <>{clue}{display}</>
  const style={borderRadius: ID=='t' ? '7px 0 0 7px' : '0 7px 7px 0'}
  return (
    <>
      <div id={`${ID}${v}`} className={`${ID} icon h1`} onClick={onClick} style={style}>
        {print}
      </div>
      <div {...p} style={style}>
        <div className='mount'>
          {<Table {...pp}/>}
        </div>
      </div>
    </>
  )
}
export default Side
